import React, { useEffect, useMemo, useState } from "react";
import { getUser } from "../../../services/utils";
import { FeedbackEntry } from "../Feedback.types";
import { api } from "../../../services/api";
import { useAdminUsers } from "../../manageAdmin/context/AdminUsersContext";
import { AdminPermission } from "../../manageAdmin/AdminUserList.types";

export const FeedbackContext = React.createContext<{ feedbackEntries: Array<FeedbackEntry>; refreshEntries: () => {} }>({
  feedbackEntries: [],
  refreshEntries: () => ({}),
});

export function FeedbackProvider({ children }) {
  const { myPermissions } = useAdminUsers();
  const user = getUser();
  const [feedbackEntries, setFeedbackEntries] = useState<Array<FeedbackEntry>>([]);

  const fetchEntries = useMemo(
    () => async () => {
      if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_FEEDBACK)) {
        const result = await api.getFeedbackEntries()
        setFeedbackEntries(result);
      }
    },
    [myPermissions]
  );

  useEffect(() => {
    if (user?.id) {
      fetchEntries();
    }
  }, [user?.id, myPermissions]);

  const values = useMemo(
    () => ({
      feedbackEntries: feedbackEntries,
      refreshEntries: fetchEntries,
    }),
    [feedbackEntries, fetchEntries]
  );

  return <FeedbackContext.Provider value={values}>{children}</FeedbackContext.Provider>;
}

export function useFeedback() {
  const context = React.useContext<{ feedbackEntries: Array<FeedbackEntry>; refreshEntries: () => {} }>(FeedbackContext);
  if (context === undefined) {
    throw new Error("useFeedback must be used within a FeedbackProvider");
  }
  return context;
}
